/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import ReportSheetsFilter from "../../ReportPage/ReportSheetsFilter/ReportSheetsFilter";
import { popupcontext } from "../../../../context/Popupscontext";
import trans, { isRTL } from "../../../../utils";
import { filtrationcontext } from "../../../../context/Filtercontext";
import Button from "../../../Helpers/Button/Button";
import ReportColumnSettings from "../../ReportColumns/ReportColumnSettings";
import { DatePicker, Flex } from "antd";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useLazyGetSpecificDeviceQuery } from "../../../../Redux/Devicestwo";

const { RangePicker } = DatePicker;

export default function ReportSheetsHead({
	setStartDate,
	startDate,
	setEndDate,
	endDate,
	selectedUser,
	selectedVehicles,
	setSelectedUser,
	setSelectedVehicles,
	selectedGroupId,
	setSelectedGroupId,
	dueWithin,
	setDueWithin,
	setIsShown,
	isShown,
}) {
	const { handleShow } = useContext(popupcontext);
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const [trigger, { data: name }] = useLazyGetSpecificDeviceQuery();
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const dateFormat = "YYYY-MM-DD HH:mm:ss";
	const { pathname } = useLocation();
	const getShortPath = () => pathname.split("/").pop();
	const shortPath = getShortPath();

	useEffect(() => {
		if (selectedVehicles && shortPath === "route") {
			console.log("selectedVehicles", selectedVehicles);
			trigger(selectedVehicles);
		}
	}, [selectedVehicles]);
	return (
		<div className="report-sheet-head flex-between mb-3">
			{/* <Searchbar
        style="search search-dark input-group"
        path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
        placeholder={trans("Search")}
        value={query}
        onChange={handleSearch}
      /> */}
			<div />
			<Flex vertical={false} gap={10}>
				{name ? <div>Vehicle Selected: {name?.[0].name}</div> : ""}
				{shortPath !== "maintenance" && (
					<RangePicker
						showTime
						value={
							startDate && endDate
								? [dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]
								: ""
						}
						placeholder={[trans("Start Date"), trans("End Date")]}
						disabled={true}
					/>
				)}
				<Button
					img={!isRTL ? "Filter.svg" : ""}
					img2={isRTL ? "Filter.svg" : ""}
					onClick={() => {
						handleShow("addForm");
						setIsShown(false);
					}}
					type={"default"}
					text={trans("Filter")}
				/>
				<ReportColumnSettings />
			</Flex>
			<ReportSheetsFilter
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				selectedUser={selectedUser}
				setSelectedUser={setSelectedUser}
				setSelectedVehicles={setSelectedVehicles}
				selectedVehicles={selectedVehicles}
				isShown={isShown}
				setIsShown={setIsShown}
				selectedGroupId={selectedGroupId}
				setSelectedGroupId={setSelectedGroupId}
				dueWithin={dueWithin}
				setDueWithin={setDueWithin}
			/>
		</div>
	);
}
